import {
    ADD_NEW_PAYMENT_METHOD_SUCCESS,
    ADD_PAYMENT_METHOD,
    API_FAILURE,
    CHANGE_PAYMENT_METHOD,
    CHANGE_PAYMENT_METHOD_SUCCESS,
    MAKE_LOAN_PAYMENT_LOAD,
    PAYMENT_SUCCESS,
    SUBMITTING_PAYMENT
} from '../actions/types';

const INITIAL_STATE = {
    visibleMakePayment: true,
    visibleChangePayment: false,
    visibleAddNewCard: false,
    addPaymentMethodSuccess: false,
    changePaymentMethodSucess: false,
    paymentSuccess: false,
    selectedLoan: null,
    submitting: false,
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CHANGE_PAYMENT_METHOD_SUCCESS: 
            return {
                ...state,
                visibleMakePayment: true,
                visibleChangePayment: false,
                visibleAddNewCard: false,
            }

        case CHANGE_PAYMENT_METHOD:

            return {
                ...state,
                visibleMakePayment: false,
                visibleChangePayment: true,
                visibleAddNewCard: false,
                changePaymentMethodSucess: true,
            }
        
        case MAKE_LOAN_PAYMENT_LOAD:
            return {
                ...state,
                visibleMakePayment: true,
                visibleChangePayment: false,
                visibleAddNewCard: false,
                addPaymentMethodSuccess: false,
                changePaymentMethodSucess: false,
                paymentSuccess: false,
            }
        case ADD_PAYMENT_METHOD:
        
            return {
                ...state,
                visibleMakePayment: false,
                visibleChangePayment: false,
                visibleAddNewCard: true,
            }

        case ADD_NEW_PAYMENT_METHOD_SUCCESS:
        
            return {
                ...state,
                visibleMakePayment: false,
                visibleChangePayment: true,
                visibleAddNewCard: false,
                addPaymentMethodSuccess: true,
            }

        case PAYMENT_SUCCESS:
        
            return {
                ...state,
                visibleMakePayment: true,
                visibleChangePayment: false,
                visibleAddNewCard: false,
                changePaymentMethodSucess: false,
                paymentSuccess: true,
                submitting: false
            }

        case SUBMITTING_PAYMENT:

            return {
                ...state,
                submitting: true,
            }

        case API_FAILURE:

            return {
                ...state,
                submitting: false,
            }
        default:

            return { ...state };
    }
}